import CustomerApplicationEdit from  '@/views/crm/customer/customerApplication/edit.vue'
import CrmCustomerChangeEdit from  '@/views/crm/customer/customerAlter/edit.vue'
import CreditOrderEdit from  '@/views/crm/order/creditOrder/edit.vue'
import ReturnGoodsOrderEdit from  '@/views/crm/order/returnGoodsOrder/edit.vue'
import SalesOrderEdit from  '@/views/crm/order/salesOrder/edit.vue'
import UnpricedOrderEdit from  '@/views/crm/order/unpricedOrder/edit.vue'
import DeliveryNoteEdit from  '@/views/crm/deliver/deliveryNote/edit.vue'
import TenderApplicationEdit from  '@/views/crm/tender/tenderApplication/edit.vue'
import PreSaleOrderEdit from  '@/views/crm/order/preSaleOrder/edit.vue'
import WorkSheetEdit from  '@/views/crm/outsource/workSheet/edit.vue'
import CustomerVisitRecordEdit from  '@/views/crm/customer/customerVisitRecord/edit.vue'


export default [
    CustomerApplicationEdit,
    CrmCustomerChangeEdit,
    CreditOrderEdit,
    ReturnGoodsOrderEdit,
    SalesOrderEdit,
    UnpricedOrderEdit,
    DeliveryNoteEdit,
    TenderApplicationEdit,
    PreSaleOrderEdit,
    WorkSheetEdit,
    CustomerVisitRecordEdit
]

